import { render, staticRenderFns } from "./ProposalCardHeader.vue?vue&type=template&id=6c3c392b"
import script from "./ProposalCardHeader.vue?vue&type=script&lang=js"
export * from "./ProposalCardHeader.vue?vue&type=script&lang=js"
import style0 from "./ProposalCardHeader.vue?vue&type=style&index=0&id=6c3c392b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports